import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HelpersService } from './helpers.service';

@Injectable({
  providedIn: 'root'
})
export class ScrollSpyService {

  private observer: IntersectionObserver | null = null;
  private activeSectionSubject = new BehaviorSubject<string | null>(null);
  activeSection$ = this.activeSectionSubject.asObservable();

  helpersService = inject(HelpersService);

  constructor() { }

  initObserver(sectionIds: string[]) {
    if (typeof IntersectionObserver === 'undefined') {
      console.warn('IntersectionObserver is not supported in this environment.');
      return; // ✅ Prevent errors in unsupported environments
    }

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.activeSectionSubject.next(entry.target.id);
        }
      });
    }, options);

    sectionIds.forEach(id => {
      if (!this.helpersService.validatePlatform()) return;
      const element = document.getElementById(id);
      if (element) {
        this.observer!.observe(element);
        // ✅ Check if the element is already visible on load
        if (this.isElementInViewport(element)) {
          this.activeSectionSubject.next(id);
        }
      }
    });
  }

  // ✅ Helper function to check if an element is in the viewport
  private isElementInViewport(el: HTMLElement) {
    if (!this.helpersService.validatePlatform()) return;
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  
    const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
    const elementHeight = rect.height;
  
    return (visibleHeight / elementHeight) >= 0.1; // ✅ At least 10% visibility
  }

  disconnectObserver() {
    this.observer?.disconnect();
  }

}
